import React, { useState } from 'react';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import { submitContact } from '../services/api';
import './ContactUs.css';

const contactItems = [
  { icon: '📧', label: 'Email Us', content: <a href="mailto:support@abmeribaari.com">support@abmeribaari.com</a> },
  { icon: '📱', label: 'Call Us', content: <a href="tel:+919098099553">+91 909-809-9553</a> },
  { icon: '📍', label: 'Our Address', content: <p>63 B Saraswati Nagar, Indore,<br />Madhya Pradesh, India — 452001</p> },
  { icon: '⏰', label: 'Business Hours', content: <p>Mon–Fri: 9 AM–6 PM<br />Saturday: 10 AM–4 PM<br />Sunday: Closed</p> },
];

const INITIAL_FORM = { name: '', email: '', subject: '', message: '' };

function ContactUs() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [focused, setFocused] = useState('');

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await submitContact(form);
      setSubmitted(true);
      setForm(INITIAL_FORM);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Hero */}
      <section className="contact-hero">
        <Reveal>
          <h1>Get In Touch With Us</h1>
        </Reveal>
        <Reveal delay={80}>
          <p>Have a question, feedback, or want to know more about our courses? We're here to help.</p>
        </Reveal>
      </section>

      {/* Body */}
      <div className="contact-body">
        <div className="contact-body-inner">

          {/* Info column */}
          <div className="contact-info-panel">
            <Reveal>
              <h2>Contact Information</h2>
              <p>Reach out through any channel below and our team will respond within 24 hours.</p>
            </Reveal>
            <div className="contact-items">
              {contactItems.map((item, i) => (
                <Reveal key={item.label} delay={i * 70} className="contact-item">
                  <div className="contact-item-icon">{item.icon}</div>
                  <div className="contact-item-body">
                    <h4>{item.label}</h4>
                    {item.content}
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Form column */}
          <Reveal direction="left" className="contact-form-panel">
            {submitted ? (
              <div className="contact-success">
                <div className="contact-success-icon">🎉</div>
                <h3>Message Sent!</h3>
                <p>Thanks for reaching out. We'll get back to you within 24 hours.</p>
                <button
                  className="submit-btn"
                  style={{ marginTop: '20px' }}
                  onClick={() => setSubmitted(false)}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <>
                <h2>Send Us a Message</h2>

                {error && (
                  <div className="contact-error">
                    ❌ {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name</label>
                      <input
                        type="text" id="name" name="name"
                        placeholder="Priya Sharma"
                        value={form.name} onChange={handleChange}
                        onFocus={() => setFocused('name')}
                        onBlur={() => setFocused('')}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <input
                        type="email" id="email" name="email"
                        placeholder="priya@example.com"
                        value={form.email} onChange={handleChange}
                        onFocus={() => setFocused('email')}
                        onBlur={() => setFocused('')}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text" id="subject" name="subject"
                      placeholder="How can we help you?"
                      value={form.subject} onChange={handleChange}
                      onFocus={() => setFocused('subject')}
                      onBlur={() => setFocused('')}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message" name="message"
                      placeholder="Write your message here..."
                      value={form.message} onChange={handleChange}
                      onFocus={() => setFocused('message')}
                      onBlur={() => setFocused('')}
                      required
                    />
                  </div>

                  <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Message →'}
                  </button>
                </form>
              </>
            )}
          </Reveal>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ContactUs;
